<script setup lang="ts">
import { DEFAULT_PRIVACY_PREFS } from '~/constants'

const emit = defineEmits<{
  saved: []
}>()

const { readPrefs, readLocalPrefs, updatePrefs } = usePrivacy()

const initialModel = {
  analytics: true,
  marketing: true,
  functionality: true,
}

const prefsModel = ref<PrivacyPrefs>(initialModel)

onMounted(() => {
  if (readLocalPrefs.value)
    prefsModel.value = readPrefs.value
})

watch(readPrefs, (newPrefs) => {
  prefsModel.value = newPrefs
})

function handleSave() {
  updatePrefs(prefsModel)
  emit('saved')
}
</script>

<template>
  <div class="py-4 space-y-8 px-card">
    <h2 class="text-2xl w-min heading md:w-auto">
      Privacy Preferences
    </h2>
    <div class="gap-x-6 gap-y-4 grid grid-cols-[max-content_auto] items-start">
      <InputCheckbox
        id="privacy-pref-analytics"
        v-model="prefsModel.analytics"
        label="Analytics"
      />
      <p class="text-sm opacity-80">
        Help us improve our website by collecting anonymous usage data.
      </p>
      <InputCheckbox
        id="privacy-pref-marketing"
        v-model="prefsModel.marketing"
        label="Marketing"
      />
      <p class="text-sm opacity-80">
        Allow personalized advertisements and measure ad effectiveness.
      </p>
      <InputCheckbox
        id="privacy-pref-functionality"
        v-model="prefsModel.functionality"
        disabled
        label="Functionality"
      />
      <p class="text-sm opacity-80">
        Essential cookies required for the website to function. Always active.
      </p>
    </div>
    <div class="flex gap-x-8 items-end justify-between">
      <div class="flex flex-col gap-x-4 media-[(pointer:fine)]:gap-y-4">
        <AButton
          size="small"
          @click="prefsModel = initialModel"
        >
          Accept All
        </AButton>
        <AButton
          size="small"
          @click="prefsModel = DEFAULT_PRIVACY_PREFS"
        >
          Reject All
        </AButton>
      </div>
      <AButton
        color="blue"
        size="small"
        @click="handleSave()"
      >
        Save
      </AButton>
    </div>
  </div>
</template>
